@if (cols && rows && rows.length) {
<table
  mat-table
  [dataSource]="rows"
  class="w-100 mat-elevation-z2"
  [ngClass]="tableClass"
  matSort
  (matSortChange)="onSort($event)"
  [matSortActive]="sort?.active"
  [matSortDirection]="sort?.direction"
>
  @for (column of cols; track column) {
  <ng-container matColumnDef="{{ column.prop || 'links' }}">
    <!-- Header -->
    <th
      mat-header-cell
      *matHeaderCellDef
      class="{{ column.classHeader }}"
      [ngStyle]="column.styleHeader"
      mat-sort-header
      [disabled]="!column.sortable"
    >
      {{ column.name }}
    </th>
    <!-- Cell -->
    <td mat-cell *matCellDef="let item" class="{{ column.classRow }}" [ngStyle]="column.styleRow">
      @if (column.cellTemplate) {
      <ng-container
        [ngTemplateOutlet]="column.cellTemplate"
        [ngTemplateOutletContext]="{ row: item, value: item[column.prop] }"
      ></ng-container>
      } @if (!column.cellTemplate) {
      <span>
        {{ item[column.prop] }}
      </span>
      }
    </td>
  </ng-container>
  }
  <tr mat-header-row *matHeaderRowDef="columnIdentifiers"></tr>
  <tr mat-row *matRowDef="let row; columns: columnIdentifiers"></tr>
</table>
} @if (cols && rows && rows.length) {
<mat-paginator
  [length]="pagination.length"
  [pageSize]="pagination.pageSize"
  [pageSizeOptions]="[5, 10, 25, 100]"
  [pageIndex]="pagination.pageIndex"
  (page)="onPageChange($event)"
  class="mat-elevation-z2"
  [ngClass]="paginatorClass"
></mat-paginator>
} @if (rows.length === 0 && !isLoading) {
<app-alert class="m-3" type="info" text="Nessun dato disponibile"></app-alert>
}

<ng-template #detailLinkHeaderTmpl let-column="column"></ng-template>

<ng-template #detailLinkCellTmpl let-row="row" let-value="value">
  <div class="w-100 d-flex justify-content-end">
    @if (!extraButtonsTmpl) { @if (_showDeleteBtn(row)) {
    <button mat-icon-button class="mr-2" (click)="deleteRow(row)" title="{{ 'GRID.DELETE' | translate }}">
      <mat-icon>delete</mat-icon>
    </button>
    } @if (showDetailLink) {
    <button mat-icon-button [routerLink]="[detailUrl(), row[trackBy]]" title="{{ 'GRID.DETAIL' | translate }}">
      <mat-icon>arrow_forward_ios</mat-icon>
    </button>
    } } @if (extraButtonsTmpl) {
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <ng-container *ngTemplateOutlet="extraButtonsTmpl; context: { row: row }"></ng-container>
      @if (_showDeleteBtn(row)) {
      <button mat-menu-item (click)="deleteRow(row)" title="{{ 'GRID.DELETE' | translate }}">
        <mat-icon class="mr-2">delete</mat-icon>
        Elimina
      </button>
      } @if (showDetailLink) {
      <button mat-menu-item [routerLink]="[detailUrl(), row[trackBy]]" title="{{ 'GRID.DETAIL' | translate }}">
        <mat-icon class="mr-2">navigate_next</mat-icon>
        Dettagli
      </button>
      }
    </mat-menu>
    }
  </div>
</ng-template>
